import { observer } from 'mobx-react';
import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';

import { useProfileStore } from '@/stores/RootStore';

import routePaths from './routePaths';

function AuthenticatedRoute({ children }: PropsWithChildren) {
  const profileStore = useProfileStore();

  if (!profileStore.profile?.id) {
    return <Navigate to={routePaths.root} replace />;
  }

  // Redirect wedissimo users to the correct dashboard
  if (import.meta.env.VITE_URL !== 'https://app.wedissimo.com' && import.meta.env.VITE_STRIPE_MODE === 'live' && profileStore.profile?.isWedissimoUser && profileStore.profile?.wedissimoUserType !== 'contact') {
    window.location.assign('https://app.wedissimo.com');
  }

  return <>{children}</>;
}

export default observer(AuthenticatedRoute);
